import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Home from '@/pages/home';
import { ROUTES } from '@/config/routes';
import { GrainProvider } from '@flodesk/grain';

export default function Routes() {
  return (
    <GrainProvider>
      <Switch>
        <Route exact path={ROUTES.home} component={Home} />
      </Switch>
    </GrainProvider>
  );
}
